import React, { PropsWithChildren, memo } from 'react'

interface IIf {
  condition: boolean
}
const If: React.FC<PropsWithChildren<IIf>> = ({ condition, children }) => {
  if (!condition) return null
  return <>{children}</>
}

const MemoIf = memo(If)

export default MemoIf
